import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ListData} from '../../Interfaces/ListData';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {ContainerView} from '../../Interfaces/ContainerView';

import {GuaranteesView} from '../../Interfaces/GuaranteesView';
import {ContainerGuarantee} from '../../Interfaces/ContainerGuarantee';
import {animate, state, style, transition, trigger} from '@angular/animations';

import {DailyRates} from '../../Interfaces/DailyRates';
import {GlobalEventsManager} from '../../GlobalEventManager';
import * as XLSX from 'xlsx';
import {ContainerViewChargesExcel} from '../../Interfaces/ContainerViewChargesExcel';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatCalendarCellCssClasses} from '@angular/material/datepicker';

@Component({
  selector: 'app-charges-calculator',
  templateUrl: './charges-calculator.component.html',
  styleUrls: ['./charges-calculator.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class ChargesCalculatorComponent implements OnInit, OnDestroy {
  txtFromArea: string;
  public qvColumns: string[];
  public demCols: string[];
  expandedElement: any;
  private last_full_date: string;
  private last_full_date_power: string;
  private last_type: string; foundStorageSSL: boolean = false;
  private last_end_date: string;
  private last_end_date_power: string;
  private last_begin_date: string;
  private last_begin_date_power: string;
  private workGuaranteesArray: GuaranteesView[];

  private chargesExcelArray: ContainerViewChargesExcel[] = [];
  private chargesExcel: ContainerViewChargesExcel;
  quickViewData: MatTableDataSource<ContainerView>;
  quickViewData2: MatTableDataSource<DailyRates>;
  dRateArray: DailyRates[] = [];
  grandTotalDisp: string;
  dRate: DailyRates;
  submitted = false;
  oneIsInAlready = false;
  foundOne = false;
  nothingSelected = false;
  private date1: Date;
  private number1: number;
  private contGuarantee: ContainerGuarantee;
  private contGuarArray: ContainerGuarantee[] = [];
  private workContGuarArray: ContainerGuarantee[] = [];
  private workArray: any[] = [];
  workDateasString: string;
  workDate: Date;

  calendarDates: { date: string, payType: string, guarantee_type: string }[];
  private dateFilter: (date: Date, rowIn: GuaranteesView) => boolean;
  @ViewChild('datepickerFooter') datepickerFooter: ElementRef;


  private options4: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric"};
  private optionsFuture: Intl.DateTimeFormatOptions = {weekday: "long", month: "2-digit", day: "2-digit", year: "numeric"};
  private options3: { currencyDisplay: string; minimumFractionDigits: number; style: string; currency: string } = {style: 'currency', currency: 'USD', currencyDisplay: 'symbol', minimumFractionDigits: 2};
  private options: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric"};
  public didntEnterShit: boolean = false;
  public badChars: boolean = false;
  public noPayType: boolean = false;
  public savedList: string;
  public containerNum: string;
  public savedLists: { id: string, code: string, description: string }[] = [];
  myNewListName: string = "";
  private listData: ListData[];
  private listDataObj: ListData;
  public insertNoConts: boolean = false;
  public noListName: boolean = false;
  public insertListExists: boolean = false;
  private clientRequest: ClientRequest;
  private contViewArray: ContainerView[] = [];
  private holdContViewArray: ContainerView[] = [];
  private contView: ContainerView;
  private guaranteesView: GuaranteesView;
  search1: UntypedFormControl;
  private specificDatesForGuarantees: GuaranteesView[] = [];
  private startDateIndx: number;
  takenDates: { date: string, container: string, event: string}[];
  reeferTakenDates: { date: string, container: string, event: string}[];
  workTakenDates: { date: string, container: string}[];
  private chargeType: string;
  private currentContainer: string;
  private currentEvent: string;
  private startingDateString: string;
  sub: any;
  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData != undefined) {
      this.quickViewData.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData != undefined) {
      this.quickViewData.paginator = pag;
    }
  }

  txtArray2: string [] = [];
  myUser: User;
  subscription: Subscription;
  demBalCol: string = "Demurrage Balance";
  reefBalCol: string = "Reefer Balance";
  powerFTE: string = "Power FTE";
  public showQuickView: boolean = false;
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;
  ipadApp: boolean = false;


  returnToSearch(){
    if (this.ipadApp){
      this.inSearch = false;
      this.ipadAppear = true;
      this.showQuickView = false;
    }
  }


  checkIfDateIsGoodForDuplicate(rowIn: ContainerView, typeIn: string) :boolean {
    if (typeIn==this.last_type) {



      if (typeIn=="STORAGE"){
        var lastStart = this.getNiceDate3(this.last_begin_date);
        var lastEnd = this.getNiceDate3(this.last_end_date);
        var rowStart = this.getNiceDateTimeForDate2(rowIn.start_datefmt);
      }else{
        var lastStart = this.getNiceDate3(this.last_begin_date_power);
        var lastEnd = this.getNiceDate3(this.last_end_date_power);
        var rowStart = this.getNiceDateTimeForDate2(rowIn.rstart_datefmt);
      }
      var rowEnd = this.getNiceDateTimeForDate2(rowIn.end_datefmt);
      var rowStart2 = this.getNiceDate3(rowStart);
      var rowEnd2 = this.getNiceDate3(rowEnd);

      if (lastStart.getTime() >= rowStart2.getTime() && lastEnd.getTime() <= rowEnd2.getTime()) { //check if dates chosen are between begin and end dates of each record
        var beginDate = null, endDate = null;
        if (typeIn=="STORAGE"){
          beginDate = this.getNiceDate3(this.last_begin_date);
          endDate = this.getNiceDate3(this.last_end_date);
        }else{
          beginDate = this.getNiceDate3(this.last_begin_date_power);
          endDate = this.getNiceDate3(this.last_end_date_power);
        }



        this.workGuaranteesArray = [];
        this.workGuaranteesArray = rowIn.guaranteesArray.filter(xx => xx.event_type == typeIn && xx.id == rowIn.container);

        for (var items of this.workGuaranteesArray) {
          var guaranteeStart = null, guaranteeEnd = null;
          guaranteeStart = this.getNiceDate3(items.guarantee_start_day);
          guaranteeEnd = this.getNiceDate3(items.guarantee_end_day);

          if (items.voided_or_expired_date != null) {
            continue;
          }

          if (beginDate.getTime() == guaranteeStart.getTime()){
            return false;
          }
          if (beginDate.getTime() == guaranteeEnd.getTime()){
            return false;
          }
          if (endDate.getTime() == guaranteeStart.getTime()){
            return false;
          }
          if (endDate.getTime() == guaranteeEnd.getTime()){
            return false;
          }

          if (beginDate.getTime() >= guaranteeStart.getTime() && endDate.getTime() <= guaranteeEnd.getTime()) {
            return false;
          }
          if (beginDate.getTime() <= guaranteeEnd.getTime() && endDate.getTime() >= guaranteeEnd.getTime()) {
            return false;
          }
        }
        return true;
      }
      return false;
    }else{
      return false;

    }
  }


  clearAllDates(fromWhere: string){
    this.contViewArray.forEach(row => {
      if (row.freight_kind=="MTY"|| row.category=="EXPRT"   || row.charges.length==0 ||  (row.chargeDisplay!=null && (row.chargeDisplay.toUpperCase().includes('EXAM') &&  !row.chargeDisplay.toUpperCase().includes('REDELIVER')))) {
      }else {

        if (row.charges.length > 1) {
          for (var xxx = 0; xxx < row.charges.length; xxx++) {
            if ((row.charges[xxx].type != null && (row.charges[xxx].type.toUpperCase().includes('EXAM') && !row.charges[xxx].type.toUpperCase().includes('REDELIVER')))) {
            } else {
              row.expanded = "N";
              if (fromWhere == "S") {
                row.full_date = null;
                row.start_date_in = null;
                row.end_date_in = null;
                this.last_begin_date = null;
                this.last_end_date = null;
                this.last_full_date = null;
                var dd = this.holdContViewArray.findIndex(ll => ll.container == row.container);
                if (dd != -1) {
                  row.demurrageBalanceDue = this.holdContViewArray[dd].demurrageBalanceDue;
                  if (row.demurrageDays == "0") {
                    row.demurrageBalanceDue = null;
                  } else if (row.demurrageBalanceDue != null) {
                    row.demurrageBalanceDue = this.getNiceCurrency(row.demurrageBalanceDue);
                  }
                }
              } else {
                row.full_date2 = null;
                row.start_date_in2 = null;
                row.end_date_in2 = null;
                this.last_begin_date_power = null;
                this.last_end_date_power = null;
                this.last_full_date_power = null;
                var dd = this.holdContViewArray.findIndex(ll => ll.container == row.container);
                if (dd != -1) {
                  row.powerBalanceDue = this.holdContViewArray[dd].powerBalanceDue;
                  if (row.powerDays == "0") {
                    row.powerBalanceDue = null;
                  } else if (row.powerBalanceDue != null) {
                    row.powerBalanceDue = this.getNiceCurrency(row.powerBalanceDue);
                  }
                }
              }
              this.expandedElement = null;
            }
          }
        } else {
          row.expanded = "N";
          if (fromWhere == "S") {
            row.full_date = null;
            row.start_date_in = null;
            row.end_date_in = null;
            this.last_begin_date = null;
            this.last_end_date = null;
            this.last_full_date = null;
            var dd = this.holdContViewArray.findIndex(ll => ll.container == row.container);
            if (dd != -1) {
              row.demurrageBalanceDue = this.holdContViewArray[dd].demurrageBalanceDue;
              if (row.demurrageDays == "0") {
                row.demurrageBalanceDue = null;
              } else if (row.demurrageBalanceDue != null) {
                row.demurrageBalanceDue = this.getNiceCurrency(row.demurrageBalanceDue);
              }
            }
          } else {
            row.full_date2 = null;
            row.start_date_in2 = null;
            row.end_date_in2 = null;
            this.last_begin_date_power = null;
            this.last_end_date_power = null;
            this.last_full_date_power = null;
            var dd = this.holdContViewArray.findIndex(ll => ll.container == row.container);
            if (dd != -1) {
              row.powerBalanceDue = this.holdContViewArray[dd].powerBalanceDue;
              if (row.powerDays == "0") {
                row.powerBalanceDue = null;
              } else if (row.powerBalanceDue != null) {
                row.powerBalanceDue = this.getNiceCurrency(row.powerBalanceDue);
              }
            }
          }
          this.expandedElement = null;
       }

        }
    })
  }

  setAllDates() {
    this.contViewArray.forEach(row => {
      if ((this.last_full_date==null && this.last_full_date_power==null) ||row.freight_kind=="MTY" || row.category=="EXPRT"|| row.charges.length==0 || (row.chargeDisplay!=null && (row.chargeDisplay.toUpperCase().includes('EXAM') &&  !row.chargeDisplay.toUpperCase().includes('REDELIVER')))  ) {
      }else{
        if (row.charges.length>1 && row.maherError==null){
          for (var xxx=0; xxx<row.charges.length; xxx++){
            if ( (row.charges[xxx].type!=null  && (row.charges[xxx].type.toUpperCase().includes('EXAM') &&  !row.charges[xxx].type.toUpperCase().includes('REDELIVER')))  || !this.checkIfDateIsGoodForDuplicate(row, row.charges[xxx].type) ) {
            }else{
              row.expanded="Y";
              if (this.last_type=="STORAGE"){
                row.start_date_in = this.last_begin_date;
                row.end_date_in = this.last_end_date
                row.full_date = this.last_full_date;
              }else{
                row.start_date_in2 = this.last_begin_date_power;
                row.end_date_in2 = this.last_end_date_power;
                row.full_date2 = this.last_full_date_power;
              }
            }
          }
        }else{
          if (row.charges.length==1){
            if (row.maherError!=null || row.charges[0].flatRate=="Y"  || !this.checkIfDateIsGoodForDuplicate(row, row.charges[0].type)){
            }else{
              row.expanded="Y";
              if (this.last_type=="STORAGE"){
                row.start_date_in = this.last_begin_date;
                row.end_date_in = this.last_end_date
                row.full_date = this.last_full_date;
              }else{
                row.start_date_in2 = this.last_begin_date;
                row.end_date_in2 = this.last_end_date
                row.full_date2 = this.last_full_date;
              }

            }
          }
        }
      }
    })
  }



  constructor(fb: UntypedFormBuilder, private router: Router, private service: SharedVarService, private  globalEventsManager: GlobalEventsManager,private myApp: AppComponent, private queryService: QueryService) {

    this.qvColumns = ["container", "iso", "line_id", "vesselVoyage", "fte_date_fmt","gDate","totalAmountMaher","totalAmountLine",  "demurrageBalanceDue", "power_fte_date_fmt", "rDate", "powerBalanceDue"];
    this.demCols = ["type","description", "quantityBilled", "rate", "totalAmount","blank"];


    this.myUser = this.myApp.user;
    this.service.myUser = this.myUser;

/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = " ";
    this.myUser.company_code = "EGN"
   this.myUser.company_code = "M0995"
    this.myUser.company_name = "MAHER TERMINALS, LLC"
    this.myUser.city = "HOUSTON"
    this.myUser.email_address = "miller@maherterminals.com"
    this.myUser.fax_number = null
    this.myUser.first_name = "Csp Craig"
    this.myUser.last_name = "Miller"
    this.myUser.maherError = null
    this.myUser.old_password = null
    this.myUser.password = ""
    this.myUser.phone_number = null
    this.myUser.company_scac = null
    this.myUser.state = "TX"
    this.myUser.userMenuReportItemsView = null
    this.myUser.user_gkey = "8237887"
   this.myUser.role = "AGENT"
   //   this.myUser.role= "SHIPPER"
  // this.myUser.role= "LINEOP"
    this.myUser.username = "CDOUG";
  //  this.myUser.username = "CSPSSL";
    this.myUser.menuRoleArray = [];
    this.myUser.menuRoleArray[0] = "CSP_CONSIGNEE_ROLE";
    this.myUser.zip = "07201"

    this.myUser.canSeeAllData = "1";
    this.myUser.callingCalculator = "Y";
    this.service.myUser = this.myUser;



 */







   this.sub =  this.service.getConfirmed().subscribe((value) => {
      if (value){
        this.updateContainerList('D');
        this.service.setConfirmed(false);
      }
    });

    this.dateFilter = (date: Date, rowIn: GuaranteesView) => {

      this.calendarDates = null;
      this.calendarDates = [];
      let workDate = this.getNiceDateTimeForDate2(date);
      if (this.specificDatesForGuarantees == undefined || this.specificDatesForGuarantees.length == 0) {
        return true;
      }
      var indx = this.specificDatesForGuarantees.findIndex(xx => Date.parse(xx.guarantee_start_day) == Date.parse(workDate) && (xx.event_type == this.chargeType || xx.event_type=="STPAID") && xx.voided_or_expired_date == null);
      if (indx != -1) {
        this.startDateIndx = indx;
        this.calendarDates.push({"date": date.getDate().toString(), "payType": this.specificDatesForGuarantees[indx].payment_type,"guarantee_type": this.specificDatesForGuarantees[indx].guarantee_type});
        if (this.currentEvent=="Demurrage" || this.currentEvent.toUpperCase()=="STORAGE"){
          if (this.takenDates.findIndex(xx=>xx.date==workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) ==-1){
            this.takenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
          }
        }else{
          if (this.reeferTakenDates.findIndex(xx=>xx.date==workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) ==-1){
            this.reeferTakenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
          }
        }
        return false;
      }
      indx = this.specificDatesForGuarantees.findIndex(xx => Date.parse(xx.guarantee_end_day) == Date.parse(workDate) && (xx.event_type == this.chargeType || xx.event_type=="STPAID") && xx.voided_or_expired_date == null);
      if (indx != -1) {
        this.calendarDates.push({"date": date.getDate().toString(), "payType": this.specificDatesForGuarantees[indx].payment_type,"guarantee_type": this.specificDatesForGuarantees[indx].guarantee_type});
        if (this.currentEvent=="Demurrage" || this.currentEvent.toUpperCase()=="STORAGE"){
          if (this.takenDates.findIndex(xx=>xx.date==workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) ==-1){
            this.takenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
          }
        }else{
          if (this.reeferTakenDates.findIndex(xx=>xx.date==workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) ==-1){
            this.reeferTakenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
          }
        }
        return false;
      } else {
        indx = this.specificDatesForGuarantees.findIndex(xx => (Date.parse(workDate) >= Date.parse(xx.guarantee_start_day)  && Date.parse(workDate) <= Date.parse(xx.guarantee_end_day)) && (xx.event_type == this.chargeType || xx.event_type=="STPAID") && xx.voided_or_expired_date == null);
        if (indx != -1) {
          this.calendarDates.push({"date": date.getDate().toString(), "payType": this.specificDatesForGuarantees[indx].payment_type,"guarantee_type": this.specificDatesForGuarantees[indx].guarantee_type});
          if (this.currentEvent=="Demurrage" || this.currentEvent.toUpperCase()=="STORAGE"){
            if (this.takenDates.findIndex(xx=>xx.date==workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) ==-1){
              this.takenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
            }
          }else{
            if (this.reeferTakenDates.findIndex(xx=>xx.date==workDate && xx.container == this.currentContainer && xx.event == this.currentEvent) ==-1){
              this.reeferTakenDates.push({"date": workDate, "container": this.currentContainer, "event": this.currentEvent});
            }
          }
          return false;
        }
      }
      return true;
    }
  }


  fillUpSavedLists(){
    this.savedLists = [];
    for (var item of this.listData){
      if (item.type =="E"){
        this.savedLists.push({"id": item.id, "code": item.name, "description": item.name});
      }
    }
    if (this.savedLists.length>0){
      this.savedList = this.savedLists[0].id;
    }
  }

  onOpen() {
    this.appendFooter();
  }

  private appendFooter() {
    const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;
    matCalendar.appendChild(this.datepickerFooter.nativeElement);
  }


  setupRow(rowIn: GuaranteesView[], typeIn: string, startIn: Date){
    this.expandedElement = null;
    if (typeIn.toUpperCase()=='STORAGE'){
      this.chargeType = typeIn;
      this.currentEvent = typeIn;
    }else if (typeIn.toUpperCase()=='REEFER'){
      this.chargeType = typeIn;
      this.currentEvent = typeIn;

    }
    if (rowIn.length>0){
      this.currentContainer = rowIn[0].id;
    }
    this.startDateIndx = null;
    this.specificDatesForGuarantees = null;
    this.specificDatesForGuarantees = [];
    this.specificDatesForGuarantees = {} as GuaranteesView[];
    this.specificDatesForGuarantees = Object.assign([],rowIn);

    this.foundOne = false;
    this.startingDateString = this.getNiceDateTimeForDate2(startIn);

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ngOnInit() {

    this.calendarDates = [];
    this.search1 = new UntypedFormControl();
    this.service.getAllSslStorageCollections(this.myUser);
    this.getListData();
    if (window.innerWidth > 750 && window.innerWidth <1025){
      this.ipadApp = true;
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }


  dateClass() {
    return (date: Date): MatCalendarCellCssClasses => {
      var indx = this.calendarDates.findIndex(xx => xx.date == date.getDate().toString());
      if (indx != -1) {
        if (this.calendarDates[indx].guarantee_type=="CREDIT_PREAUTHORIZE") {
          return 'creditCard';
        } else if (this.calendarDates[indx].guarantee_type=="WAIVER") {
          return 'waived';
        } else if (this.calendarDates[indx].guarantee_type=="PAID" ||  this.calendarDates[indx].guarantee_type=="PRE_PAY" || this.calendarDates[indx].guarantee_type=="STPAID") {
          return 'cash';
        } else if (this.calendarDates[indx].guarantee_type=="OAC" ){
          return 'guarantee';
        }
      }
    }
  }

  exportExcel() {
    this.chargesExcelArray = [];
    for (var xx=0; xx<this.quickViewData.filteredData.length; xx++) {

      if (this.quickViewData.filteredData[xx].maherError == null && this.quickViewData.filteredData[xx].category != "EXPRT" && this.quickViewData.filteredData[xx].navisErrors == null && this.quickViewData.filteredData[xx].charges.length > 0) {
        this.chargesExcel = {} as ContainerViewChargesExcel;
        this.chargesExcel.Container = this.quickViewData.filteredData[xx].container;
        this.chargesExcel.ISO = this.quickViewData.filteredData[xx].iso;
        this.chargesExcel.SSL = this.quickViewData.filteredData[xx].line_id;
        this.chargesExcel.VesselVoyage = this.quickViewData.filteredData[xx].vesselVoyage;
        this.chargesExcel.DemurrageFTE = this.quickViewData.filteredData[xx].fte_date_fmt;
        if (this.quickViewData.filteredData[xx].full_date!=null){
          if ((this.contGuarArray.length>0 && this.contGuarArray.findIndex(dd => dd.container == this.quickViewData.filteredData[xx].container) != -1)){
            var begin = this.getNiceDate(this.quickViewData.filteredData[xx].start_date_in);
            var end = this.getNiceDate(this.quickViewData.filteredData[xx].end_date_in);
            this.chargesExcel.DemurrageStartEnd = begin + " - " + end;
          }else{
            this.chargesExcel.DemurrageStartEnd = this.getNiceDateTimeForDate2(new Date())
          }
        }else{
          this.chargesExcel.DemurrageStartEnd = this.getNiceDateTimeForDate2(new Date())
        }
        this.chargesExcel.MaherDemurrage= this.quickViewData.filteredData[xx].demurrageBalanceDueMaher;
        this.chargesExcel.LineDemurrage = this.quickViewData.filteredData[xx].demurrageBalanceDueLine;
        this.chargesExcel.TotalDemurrage = this.quickViewData.filteredData[xx].demurrageBalanceDue;
        this.chargesExcel.PowerFTE = this.quickViewData.filteredData[xx].power_fte_date_fmt;
        if (this.quickViewData.filteredData[xx].full_date2!=null){
          if ((this.contGuarArray.length>0 && this.contGuarArray.findIndex(dd => dd.container == this.quickViewData.filteredData[xx].container) != -1)){
            var begin = this.getNiceDate(this.quickViewData.filteredData[xx].start_date_in2)
            var end = this.getNiceDate(this.quickViewData.filteredData[xx].end_date_in2)
            this.chargesExcel.PowerStartEnd = begin + " - " + end;
          }else{
            this.chargesExcel.PowerStartEnd = this.getNiceDateTimeForDate2(new Date())
          }
        }else{
          this.chargesExcel.PowerStartEnd = this.getNiceDateTimeForDate2(new Date())
        }


        this.chargesExcel.PowerBal = this.quickViewData.filteredData[xx].powerBalanceDue;
        this.chargesExcelArray.push(this.chargesExcel);
      }
    }



    const workSheet = XLSX.utils.json_to_sheet(this.chargesExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:15},
      {wch:10},
      {wch:10},
      {wch:35},
      {wch:15},
      {wch:17},
      {wch:17},
      {wch:32},
      {wch:17},
      {wch:15},
      {wch:15},
      {wch:15},

    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'ContainerCharges');
    XLSX.writeFile(workBook, 'containerCharges.xlsx');
  }

  shouldShowCalendar(row: ContainerView): boolean {
    if (row.maherError!=null || row.navisErrors!=null || row.charges.length==0 || row.category=='EXPRT' ){
      return false;
    }else{
      return true;
    }
  }


  shouldShowCalendarReefer(row: ContainerView): boolean {
    if (row.maherError!=null || row.navisErrors!=null || row.charges.length==0 || (row.power_fte_date_fmt==null || row.power_fte_date_fmt=="" )) {
      return false;
    }else{
      return true;
    }
  }

  emitDates(ref,rowIn: ContainerView) {
    if (rowIn.chargeDisplay!=null && rowIn.chargeDisplay.toUpperCase().includes("REDELIVERY")){
      rowIn.end_date_in = rowIn.start_date_in;
      rowIn.full_date = rowIn.start_date_in;
    }else{
      if (rowIn.start_date_in!=undefined && rowIn.end_date_in!=undefined){
        rowIn.full_date = rowIn.start_date_in + " - " + rowIn.end_date_in;
      }
    }
    this.last_type = 'STORAGE';
    if (rowIn.full_date!=null){
      this.last_begin_date = rowIn.start_date_in;
      this.last_end_date = rowIn.end_date_in;
      rowIn.expanded = "Y";
    }else{
      rowIn.expanded = "N";
      this.last_begin_date = null;
      this.last_end_date = null;
      var dd = this.holdContViewArray.findIndex(ll => ll.container == rowIn.container);
      if (dd!=-1){
        rowIn.demurrageBalanceDue = this.holdContViewArray[dd].demurrageBalanceDue;
        if (rowIn.demurrageDays=="0"){
          rowIn.demurrageBalanceDue = null;
        }else if (rowIn.demurrageBalanceDue!=null){
          rowIn.demurrageBalanceDue = this.getNiceCurrency(rowIn.demurrageBalanceDue);
        }
        this.expandedElement = null;
      }



    }
  }
  emitDates2(ref,rowIn: ContainerView) {
    rowIn.full_date2 = rowIn.start_date_in2 + " - " + rowIn.end_date_in2;
    this.last_full_date_power = rowIn.full_date2;
    this.last_type = 'REEFER';
    if (rowIn.full_date2!=null){
      this.last_begin_date_power = rowIn.start_date_in2;
      this.last_end_date_power = rowIn.end_date_in2;
      rowIn.expanded = "Y";
    }else{
      rowIn.start_date_in2 = null;
      rowIn.end_date_in2 = null;
      rowIn.expanded = "N";
      this.last_begin_date_power = null;
      this.last_end_date_power = null;
      var dd = this.holdContViewArray.findIndex(ll => ll.container == rowIn.container);
      if (dd!=-1){
        rowIn.powerBalanceDue = this.holdContViewArray[dd].powerBalanceDue;
        if (rowIn.powerDays=="0"){
          rowIn.powerBalanceDue = null;
        }else if (rowIn.powerBalanceDue!=null){
          rowIn.powerBalanceDue = this.getNiceCurrency(rowIn.powerBalanceDue);
        }
        this.expandedElement = null;
      }
    }
  }


  checkForOverlapDates(){
    this.workContGuarArray = [];
    for (var items of this.contGuarArray){
      if ((items.fromDate == items.toDate) || items.isFlatRate=="Y"){
        continue;
      }else{
        var originalEndDate, stillGoing=true, firstTime = true;
        this.workDateasString = items.fromDate;
        originalEndDate = items.toDate;
        while(stillGoing) {


          var indx = this.quickViewData.data.findIndex(xx => xx.iufv_gkey == items.iufv_gkey);
          if (indx != -1) {
            var xxx = this.quickViewData.data[indx].charges[this.quickViewData.data[indx].charges.findIndex(yy => yy.extractGkey == items.extractGkey)].typeDescription;
            if (items.typeOfCharge.toUpperCase()=="POWER" || items.typeOfCharge.toUpperCase()=="REEFER"){
              this.workArray = Object.assign([],this.reeferTakenDates);
            }else{
              this.workArray = Object.assign([],this.takenDates);
            }


            if (this.workArray.findIndex(xx => xx.date == this.workDateasString && xx.container == items.container && xx.event == items.typeOfCharge) == -1) { //date doesnt exist on table -work with it
              this.workTakenDates = this.workArray.filter(xx => (Date.parse(xx.date) > Date.parse(this.workDateasString) &&  Date.parse(xx.date) < Date.parse(originalEndDate) ) && xx.container == items.container && xx.event == items.typeOfCharge)
              if (this.workTakenDates.length > 0) {
                if (firstTime){
                  this.workDate = this.getNiceDate3(this.workTakenDates[0].date);
                  this.workDate.setDate(this.workDate.getDate() - 1); //adding 1 to the toDate
                  this.workDateasString = this.getNiceDateTimeForDate2(this.workDate);
                  items.toDate = this.getNiceDateTimeForDate2(this.workDate);
                  firstTime = false;
                }else{
                  this.contGuarantee = null;
                  this.contGuarantee = Object.assign({},items); //clone the original record
                  this.contGuarantee.fromDate = this.workDateasString;
                  this.workDate = this.getNiceDate3(this.workTakenDates[0].date);
                  this.workDate.setDate(this.workDate.getDate() - 1); //adding 1 to the toDate
                  this.contGuarantee.toDate = this.getNiceDateTimeForDate2(this.workDate);
                  this.workDateasString = this.getNiceDateTimeForDate2(this.workDate);
                  this.workContGuarArray.push(this.contGuarantee);
                }
              }else{
                if (!firstTime){
                  this.contGuarantee = null;
                  this.contGuarantee = Object.assign({},items); //clone the original record
                  this.contGuarantee.fromDate = this.workDateasString;
                  this.contGuarantee.toDate = originalEndDate;
                  this.workContGuarArray.push(this.contGuarantee);
                }
                stillGoing = false;
                break;
              }
            }
            this.workDate = this.getNiceDate3(this.workDateasString);
            this.workDate.setDate(this.workDate.getDate() + 1); //adding 1 to the toDate
            this.workDateasString = this.getNiceDateTimeForDate2(this.workDate);
          }
        }
      }
    }

    for (var things of this.workContGuarArray){
      this.contGuarArray.push(things);
    }


  }

  getListData(){

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.listData = []
    this.listDataObj = {} as ListData;
    this.listDataObj.type = "E";
    this.listData.push(this.listDataObj);
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.listData;
    const lhsUserObs$ = this.queryService.getLists(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
          this.fillUpSavedLists();
      });
  }


  getSearchItems(){

    if (this.oneIsInAlready){
      return;
    }

    this.closeDetails();
    this.showQuickView = false;
    this.foundStorageSSL = false;
    this.service.foundStorageSSL = false;
    this.submitted = true;
    this.oneIsInAlready = true;
    this.badChars = false;
    if (this.txtFromArea==undefined){
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');


    this.txtArray2 = [];

    this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
    if (this.txtArray2.length==0){
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }
    this.didntEnterShit = false;
    var _i = this.txtArray2.length;
    while (_i--) {
      this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
      if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
        this.containerNum = this.txtArray2[_i].valueOf();
        this.badChars = true;
        this.oneIsInAlready = false;
        return;
      }

      if (this.txtArray2[_i].valueOf() == "") {
        this.txtArray2.splice(_i, 1);
      }
    }

    this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);


    this.contViewArray = [];
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.myUser.callingCalculator = "Y";
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    for (var items of this.txtArray2){
      this.contView = {} as ContainerView;
      this.contView.guaranteeType = "C";
      this.contView.container = items.valueOf();
      this.contViewArray.push(this.contView);
    }
    this.clientRequest.requestData = this.contViewArray;
    var  lhsUserObs$ = this.queryService.paymentGetContainers(this.clientRequest);

    this.subscription = lhsUserObs$.subscribe(
      (lhsUser) => {
        this.contViewArray = lhsUser;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.oneIsInAlready = false;
        this.reeferTakenDates = [];
        this.takenDates = [];
        this.submitted = false;
        this.showQuickView = true;
        this.setupScreen("G");

        if (window.innerWidth<1200){
          this.demBalCol = "Dem. Bal.";
          this.reefBalCol = "Pow. Bal";
          this.powerFTE = "Pow/FTE";
        }else  if (window.innerWidth<1625){
          this.demBalCol = "Dem. Balance";
          this.reefBalCol = "Reefer Bal.";
          this.powerFTE = "Power FTE";
        }
        if (window.innerWidth > 750 && window.innerWidth <1025){
          this.ipadAppear = false;
        }
        this.holdContViewArray = [];
        this.holdContViewArray = Object.assign([], JSON.parse(JSON.stringify(this.contViewArray)));
        this.quickViewData = new MatTableDataSource<ContainerView>(this.contViewArray);

        for (var xx of this.quickViewData.data){
          if (xx.demurrageDays=="0"){
            xx.demurrageBalanceDue = null;
            xx.demurrageBalanceDueMaher = null;
            xx.demurrageBalanceDueLine = null;
          }else if (xx.demurrageBalanceDue!=null){
            xx.demurrageBalanceDue = this.getNiceCurrency(xx.demurrageBalanceDue);
            var isDemLine = this.service.isAStorageSSL(xx.line_id);
            this.foundStorageSSL = this.service.foundStorageSSL;
            if (isDemLine=="L" || xx.maherError!=null || xx.category=="EXPRT"){
              xx.demurrageBalanceDueLine = null;
            }else if (isDemLine=="Y"){
              xx.demurrageBalanceDueLine = this.getNiceCurrency(xx.demurrageBalanceDueLine);
            }else{
              xx.demurrageBalanceDueLine = "Contact Line Op For Demurrage Owed";
            }
            if (xx.demurrageBalanceDueMaher== null || xx.demurrageBalanceDueMaher=="0.00"){
              xx.demurrageBalanceDueMaher = null;
            }else{
              xx.demurrageBalanceDueMaher = this.getNiceCurrency(xx.demurrageBalanceDueMaher);
            }
          }



          if (xx.powerDays=="0"){
            xx.powerBalanceDue = null;
          }else if (xx.powerBalanceDue!=null){
            xx.powerBalanceDue = this.getNiceCurrency(xx.powerBalanceDue);
          }
        }



      });

    //  }
  }


  setupScreen(fromWhere: string){
    for (var item of this.contViewArray){
      if (item.maherError!=null) {
        item.vesselVoyage = item.maherError;
        item.demurrageBalanceDue = null;
        item.demurrageBalanceDueLine = null;
        item.demurrageBalanceDueMaher = null;
        item.powerBalanceDue = null;
        item.fte_datefmt = null;
        item.fte_date_fmt = null;
      }else if (item.category=="EXPRT"){
        item.vesselVoyage = "Export Containers Not Allowed";
        item.demurrageBalanceDue = null;
        item.demurrageBalanceDueLine = null;
        item.demurrageBalanceDueMaher = null;
        item.powerBalanceDue = null;
        item.fte_date_fmt = null;
      }else if (item.navisErrors!=null){
        item.vesselVoyage = item.navisErrors[0];
        item.demurrageBalanceDue = null;
        item.demurrageBalanceDueLine = null;
        item.demurrageBalanceDueMaher = null;
        item.powerBalanceDue = null;
        item.fte_datefmt = null;
        item.fte_date_fmt = null;
      }else if (item.charges.length==0 ){
        item.vesselVoyage = "No Charges Due on This Container";
        item.fte_datefmt = null;
        item.fte_date_fmt = null;
        item.fte_power_datefmt = null;
        item.power_fte_date_fmt = null;
        item.demurrageBalanceDue = null;
        item.demurrageBalanceDueLine = null;
        item.demurrageBalanceDueMaher = null;
        item.powerBalanceDue = null;
        item.booking = null;
      }else{
        if (item.category_description.toUpperCase()=='IMPORT'){
          item.vesselVoyage = item.in_vessel_description + " / " + item.in_voyage;
        }else{
          if (item.out_vessel_description!=null){
            item.vesselVoyage = item.out_vessel_description + " / " + item.out_voyage;
          }
        }
        item.rangeMode = true;
        if (item.fte_date!=null && item.fte_date!=""){
          item.fte_datefmt = this.getNiceDate3(item.fte_date);
          item.fte_date_fmt = this.getNiceDate(item.fte_date_fmt);
          item.fte_datefmt.setDate(item.fte_datefmt.getDate() + 1);
          item.fte_date_fmt2 = this.getNiceDate(item.fte_date);
          item.start_datefmt = item.fte_datefmt;
        }
        if (item.power_fte_date!=null && item.power_fte_date!=""){
          item.fte_power_datefmt = this.getNiceDate3(item.power_fte_date);
          item.fte_power_datefmt.setDate(item.fte_power_datefmt.getDate() + 1);
          item.power_fte_date_fmt = this.getNiceDate(item.power_fte_date);
          item.rstart_datefmt = item.fte_power_datefmt;
        }

        if (item.storage_paid_through_date!=null && item.fte_date!=null){
          this.guaranteesView = {} as GuaranteesView;
          this.guaranteesView.id = item.container;
          this.guaranteesView.guarantee_start_day = item.fte_date;
          this.guaranteesView.guarantee_end_day = item.storage_paid_through_date;
          this.guaranteesView.event_type = "STPAID";
          this.guaranteesView.guarantee_type = "STPAID";
          this.guaranteesView.guarantee_amount = "0";
          item.guaranteesArray.push(this.guaranteesView);
        }

        item.end_datefmt = this.getNiceDate3(item.endDateForGuarantees);




        if (item.guaranteesArray!=null && item.guaranteesArray.length>0) {
          for (var gua of item.guaranteesArray) {
            gua.guarantee_start_day = this.getNiceDate(gua.guarantee_start_day);
            gua.guarantee_end_day = this.getNiceDate(gua.guarantee_end_day);
            gua.guarantee_amount = this.getNiceCurrency(gua.guarantee_amount);
            if (gua.voided_or_expired_date != null) {
              gua.voided_or_expired_date_disp = "Voided";
            } else {
              gua.voided_or_expired_date_disp = "Guaranteed";
            }
            gua.vesselVoyageDisp = item.vesselVoyage;
            gua.sslDisp = item.ssl_owner_description;
            /*
            if (gua.event_type.toUpperCase() == 'STORAGE') {
              gua.event_type = "Demurrage";
            } else if (gua.event_type.toUpperCase() == 'REEFER') {
              gua.event_type = 'Power';
            } else if (gua.event_type.toUpperCase() == 'SHIPSIDE EXAM') {
              gua.event_type = 'Shipside Exam';
            } else if (gua.event_type.toUpperCase() == 'COAST GUARD EXAM') {
              gua.event_type = 'Coast Guard Exam';
            } else if (gua.event_type.toUpperCase() == 'GATE-EXAM') {
              gua.event_type = 'Offsite Exam';
            } else if (gua.event_type.toUpperCase() == 'GATE-REDELIVERY') {
              gua.event_type = 'Export Redelivery Exam';
            }

             */
          }
        }
        var indx = item.charges.findIndex(xx => xx.type.toUpperCase().includes("REDELIVERY" ));
        if (indx!=-1){
          indx = item.charges.findIndex(xx => xx.type == "MOUNTING");
          if (indx!=-1){
            item.charges.splice(indx,1);
          }
          indx = item.charges.findIndex(xx => xx.type == "GROUNDING");
          if (indx!=-1){
            item.charges.splice(indx,1);
          }
          item.chargesBack = Object.assign([], item.charges)
          indx = item.charges.findIndex(xx => xx.type == "STORAGE");
          if (indx!=-1){
            item.charges.splice(indx,1);
          }
          indx = item.charges.findIndex(xx => xx.type == "REEFER");
          if (indx!=-1){
            item.charges.splice(indx,1);
          }
        }

     //  item.demurrageBalanceDue = null;
      //  item.powerBalanceDue = null;
        if (item.charges!=null && item.charges.length>0){
          for (var chg of item.charges){
            if (chg.type.toUpperCase()=='STORAGE'){
              if (item.fte_date_fmt!=null){
                chg.fte_datefmt = this.getNiceDate3(item.fte_date);
                chg.fte_datefmt.setDate(chg.fte_datefmt.getDate() + 1);
                chg.start_datefmt = item.fte_datefmt;
              }
             }else if (chg.type.toUpperCase()=='REEFER'){
              if (item.power_fte_date!=null){
                chg.fte_datefmt = this.getNiceDate3(item.power_fte_date);
                chg.fte_datefmt.setDate(chg.fte_datefmt.getDate() + 1);
                chg.start_datefmt = item.fte_datefmt;
              }
            }else if (chg.type.toUpperCase()=='GATE-REDELIVERY') {
              item.rangeMode = false;
            }else if (chg.type.toUpperCase()=='MOUNTING' || chg.type.toUpperCase()=='GROUNDING') {
              chg = null;
              continue;
            }
            chg.container = item.container;
            chg.iufv_gkey = item.iufv_gkey;
            chg.apiGkey = item.apiGkey;
            chg.line_id = item.line_id;

         //   chg.amout = this.getNiceCurrency(chg.amout);
          }
        }else{
          item.fte_datefmt = null;
          item.fte_date_fmt = null;
          item.fte_power_datefmt = null;
          item.power_fte_date_fmt = null;
          item.booking = null;
        }
      }
    }
  }


  verifySelection(){

    this.closeDetails();

    this.submitted = true;
    this.foundOne = false;

    for (var item of this.contViewArray){
        if (item.full_date!=null || item.full_date2!=null) {
          this.foundOne = true;
        }
    }
    if (!this.foundOne){
      this.nothingSelected = true;
      return;
    }


    this.contGuarArray = null;
    this.contGuarArray = [];
    for (var items of this.contViewArray){
      if (items.start_date_in!=null || items.start_date_in2!=null) {

        for (var chg of items.charges) {
          this.contGuarantee = {} as ContainerGuarantee;
          this.contGuarantee.apiGkey = items.apiGkey;
          this.contGuarantee.iufv_gkey = items.iufv_gkey;
          this.contGuarantee.extractGkey = chg.extractGkey;
          this.contGuarantee.category = items.category;
          this.contGuarantee.container = items.container;
          this.contGuarantee.isFlatRate = chg.flatRate;
          this.contGuarantee.isExam = "N";
          if ((chg.typeDescription.toUpperCase()=="DEMURRAGE" || chg.typeDescription.toUpperCase()=="EXPORT REDELIVERY EXAM") && items.start_date_in!=null){
            this.contGuarantee.fromDate = this.getNiceDate(items.start_date_in);
            this.contGuarantee.toDate = this.getNiceDate(items.end_date_in);
          }
          if (chg.typeDescription.toUpperCase()=="POWER" && items.start_date_in2!=null){
            this.contGuarantee.fromDate = this.getNiceDate(items.start_date_in2);
            this.contGuarantee.toDate = this.getNiceDate(items.end_date_in2);
          }
          this.contGuarantee.guaranteeType = "C";
          this.contGuarantee.line_id = items.line_id;
          this.contGuarantee.reference = items.reference_number;
          this.contGuarantee.remarks = items.remarks;
          this.contGuarantee.typeOfCharge = chg.type;
          this.contGuarArray.push(this.contGuarantee);
        }

      }
    }

    this.checkForOverlapDates();

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.contGuarArray;
    const lhsUserObs$ = this.queryService.paymentCalculateDates(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (datesBack) => {
        this.contGuarArray = datesBack;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {


        this.setupScreen("V");
        var demTotal = 0, maherTotal = 0, lineTotal = 0;
        var powerTotal = 0;
        var demFirstTime, powerFirstTime;
        var holdCont = " ";

        this.contGuarArray.sort(function(a, b) {
          if (a.container < b.container) {
            return 1;
          }
          if (a.container > b.container) {
            return -1;
          }
          return 0;
        })

        for (var tt of this.contGuarArray) {
          if (holdCont != tt.container){
            holdCont = tt.container;
            demFirstTime = true;
            powerFirstTime = true;
          }
          var indx = this.quickViewData.data.findIndex(xx => xx.iufv_gkey == tt.iufv_gkey);
          var qvIndx = this.quickViewData.data[indx].charges.findIndex(xx => xx.extractGkey == tt.extractGkey);
          if (indx != -1) {
            if (tt.isFlatRate=="Y"){
              if (qvIndx!=-1){
                this.quickViewData.data[indx].demurrageBalanceDue  = this.getNiceCurrency(this.quickViewData.data[indx].charges[qvIndx].amout);
              }
            }else{
              if (tt.typeOfCharge.toUpperCase()=="STORAGE"){
                if (demFirstTime){
                  this.quickViewData.data[indx].demurrageBalanceDue = "0";
                  demFirstTime = false;
                }
                demTotal = parseFloat(this.quickViewData.data[indx].demurrageBalanceDue.replace(/,/g, '')) + parseFloat(tt.totalAmount.replace(/,/g, ''));
                this.quickViewData.data[indx].demurrageBalanceDue = demTotal.toString();
                this.quickViewData.data[indx].demurrageBalanceDueMaher = tt.totalAmountMaher;
                var isDemLine = this.service.isAStorageSSL(tt.line_id);
                this.foundStorageSSL = this.service.foundStorageSSL;
                if (isDemLine=="L"){
                  this.quickViewData.data[indx].demurrageBalanceDueLine = null;
                }else if (isDemLine=="Y"){
                  this.quickViewData.data[indx].demurrageBalanceDueLine = this.getNiceCurrency(tt.totalAmountLine);
                }else{
                  this.quickViewData.data[indx].demurrageBalanceDueLine = "Contact Line Op For Demurrage Owed";
                }
              }else{
                if (powerFirstTime){
                  this.quickViewData.data[indx].powerBalanceDue = "0";
                  powerFirstTime = false;
                }
                powerTotal = parseFloat(this.quickViewData.data[indx].powerBalanceDue.replace(/,/g, '')) + parseFloat(tt.totalAmount.replace(/,/g, ''));
                this.quickViewData.data[indx].powerBalanceDue = powerTotal.toString();
              }
            }
          }

        }
        for (var xx of this.quickViewData.data){
          if (xx.demurrageBalanceDue!=null){
            xx.demurrageBalanceDue = this.getNiceCurrency(xx.demurrageBalanceDue);
            var isDemLine = this.service.isAStorageSSL(xx.line_id);
            this.foundStorageSSL = this.service.foundStorageSSL;
            if (isDemLine=="L"){
              xx.demurrageBalanceDueLine = null;
            }else if (isDemLine=="Y"){
              xx.demurrageBalanceDueLine = this.getNiceCurrency(xx.demurrageBalanceDueLine);
            }else{
              xx.demurrageBalanceDueLine = "Contact Line Op For Demurrage Owed";
            }

            xx.demurrageBalanceDueMaher = this.getNiceCurrency(xx.demurrageBalanceDueMaher);
          }
          if (xx.powerBalanceDue!=null){
            xx.powerBalanceDue = this.getNiceCurrency(xx.powerBalanceDue);
          }
        }
        this.submitted = false;

      });
  }


  getNiceDate(dateIn: string): string {
    this.date1 = new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options4);
  }

  getNiceDate3(dateIn: string): Date {
    this.date1 = new Date(dateIn);
    return this.date1;
  }

  getNiceDateTimeForDate2(dateIn: Date): string {
    if (dateIn!=null){
      return dateIn.toLocaleDateString("en-US", this.options);
    }else{
      return ;
    }
  }

  getNiceDateTimeForDate3(dateIn: Date): string {
    return dateIn.toLocaleDateString("en-US", this.optionsFuture);
  }

  getNiceCurrency(numberIn: string): string {
    if (numberIn.includes("$")){
      numberIn = numberIn.replace("$","");
    }
    if (numberIn.includes(",")){
      numberIn = numberIn.replace(",","");
    }

    this.number1 = parseFloat(numberIn);
    return this.number1.toLocaleString("en-US", this.options3);
  }

  showContainersFromList(){
    var indx = this.listData.findIndex(xx => xx.id == this.savedList);
    if (indx!=-1){
      this.txtFromArea = "";
      for (var ii=0;ii<this.listData[indx].data.length; ii++){
        this.txtFromArea =  this.txtFromArea + this.listData[indx].data[ii].valueOf() + '\r\n';
      }
    }
  }


  updateContainerList(fromWhere: string){
    this.submitted = true;
    this.insertNoConts = false;
    this.noListName = false;
    this.insertListExists = false;


    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.listDataObj = null;
    this.listDataObj =  {} as ListData;
    if (fromWhere=="D"){
      var indx = this.listData.findIndex(xx => xx.id == this.savedList);
      if (indx!=-1){
        this.listDataObj = this.listData[indx];
      }
      this.listDataObj.data = [];
      this.clientRequest.requestData = [];
      this.clientRequest.requestData[0] = this.listDataObj;
    }else{
      if (this.txtFromArea==undefined){
        if (fromWhere=="I"){
          this.insertNoConts = true;
        }
        return;
      }
      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length==0){
        this.didntEnterShit = true;
        return;
      }

      if (fromWhere=="I" && (this.myNewListName==null || this.myNewListName=="")){
        this.noListName = true;
        return;
      }

      if (fromWhere=="I" &&  this.listData.findIndex(xx => xx.name == this.myNewListName && xx.type == "E") !=-1){
        this.insertListExists = true;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }
      }
      if (fromWhere!="D"){
        if (fromWhere=="I"){
          this.listDataObj.type = "E";
          this.listDataObj.name = this.myNewListName;
        }else{
          var indx = this.listData.findIndex(xx => xx.id == this.savedList);
          if (indx!=-1){
            this.listDataObj = this.listData[indx];
          }
        }
        this.listDataObj.data = this.txtArray2;
        this.clientRequest.requestData = [];
        this.clientRequest.requestData[0] = this.listDataObj;
      }
    }
    this.clientRequest.user = this.myUser;
    const lhsUserObs$ = this.queryService.updateContainerList(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        var id = this.savedList;
        this.fillUpSavedLists();
        if (this.savedLists.length > 0) {
          if (fromWhere == "I") {
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.code == this.myNewListName)].id;
          } else if (fromWhere== "D") {
            this.savedList = this.savedLists[0].id;
          }else{
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.id == id)].id;
          }
        }
        this.myNewListName = "";

        if (fromWhere=="I"){
          this.myApp.showSuccessBanner("","the new list has been created successfully","chargesCalc");
        }else if (fromWhere=="D"){
          this.myApp.showSuccessBanner("",this.myNewListName + " has been deleted successfully","chargesCalc");
        }else{
          this.myApp.showSuccessBanner("","List has been updated successfully","chargesCalc");

        }

        this.submitted= false;
      });
  }

  deleteHit(){
    this.myApp.showConfirmBanner("Confirm","confirm delete of list: "+this.savedLists[this.savedLists.findIndex(xx=>xx.id==this.savedList)].description,"chargesCalc");
  }

  public wipeOutSearch(){
    this.txtFromArea = null;
    this.showQuickView = false;
  }


  closeDetails(){
    this.expandedElement = null;
  }

  expandThatShit(rowIn: ContainerView) {

    if (rowIn.expanded=="Y" && (this.contGuarArray.length>0 && this.contGuarArray.findIndex(xx => xx.container == rowIn.container) != -1)) {
        var gtot = 0, lineSub = 0;
        this.dRateArray = [];
        this.grandTotalDisp = "0.00";
        this.workContGuarArray = this.contGuarArray.filter(xx => xx.iufv_gkey == rowIn.iufv_gkey);
        for (const ss of this.workContGuarArray) {

          if (ss.isFlatRate == "Y") {
            this.dRate = {} as DailyRates;
            this.dRate.type = "Flat Rate";
            this.dRate.totalAmount = rowIn.totalAmount;
            this.dRate.quantityBilled = "1";
            this.dRateArray.push(this.dRate);
            gtot = gtot + parseFloat(this.dRate.totalAmount.replace(/,/g, ''));
          } else {

            this.dRate = {} as DailyRates;
            for (const dd of ss.dailyRates) {
              dd.rate = dd.rate.replace(/,/g, '');
              dd.rate = dd.rate.replace("$", '');
              var xx = parseFloat(dd.rate.replace(/,/g, '')) * parseFloat(dd.quantityBilled.replace(/,/g, ''));
              gtot = gtot + xx;
              dd.totalAmount = this.getNiceCurrency(xx.toString());
              dd.rate = this.getNiceCurrency(dd.rate);
              this.dRateArray.push(dd);
            }

            if (ss.dailyRatesLine!=null && ss.dailyRatesLine.length>0){
              this.dRate.totalAmount = "Subtotal: " + this.getNiceCurrency(gtot.toString());
              this.dRateArray.push(this.dRate);
              this.dRate = {} as DailyRates;
            }


            for (const dd of ss.dailyRatesLine) {
              dd.rate = dd.rate.replace(/,/g, '');
              dd.rate = dd.rate.replace("$", '');
              var xx = parseFloat(dd.rate.replace(/,/g, '')) * parseFloat(dd.quantityBilled.replace(/,/g, ''));
              lineSub = lineSub + xx;
              gtot = gtot + xx;
              dd.totalAmount = this.getNiceCurrency(xx.toString());
              dd.rate = this.getNiceCurrency(dd.rate);
              this.dRateArray.push(dd);
            }
            if (ss.dailyRatesLine!=null && ss.dailyRatesLine.length>0){
              this.dRate.totalAmount = "Subtotal: " + this.getNiceCurrency(lineSub.toString());
              this.dRateArray.push(this.dRate);
            }

          }
        }
        this.grandTotalDisp = this.getNiceCurrency(gtot.toString());
        this.dRateArray.sort(function(a, b) {
          if (a.type < b.type) {
            return 1;
          }
          if (a.type > b.type) {
            return -1;
          }
          return 0;
        })
        this.quickViewData2 = new MatTableDataSource<DailyRates>(this.dRateArray);


        this.expandedElement === rowIn ? this.expandedElement = null : this.expandedElement = rowIn;
      }
    }



}
